/* eslint-disable @typescript-eslint/no-explicit-any */
/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import {
	Box,
	Image,
	Menu,
	ActionIcon,
	rem,
} from '@mantine/core';

// Icons
import { IconTrash } from '@tabler/icons-react';
import IconDotsVertical from '@assets/icons/dots-vertical.svg';
import IconExternalLink from '@assets/icons/external-link.svg';

// Styles
import classes from './CellApiTokensActions.module.css';
import styles from './CellApiTokensActions.module.css';
import { useTranslation } from 'react-i18next';
import { ACLS } from '@config/constants/acls';
import { useAuthorization } from '@lib/authorization';
import { TApiToken } from '@features/resources/api-tokens/types';
import { ROLES } from '@config/constants/roles';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const CellApiTokensActions = (props: {
	onViewMore?: (data: TApiToken) => void;
	onDelete?: (data: TApiToken) => void;
	row?: any;
	opened?: boolean;
}) => {
	const { t } = useTranslation();
	const handleviewmore = (
		event: React.MouseEvent<HTMLElement>
	) => {
		event.stopPropagation();
		if (props && props.row) {
			props.onViewMore!(props.row);
		}
	};

	const handledeleteitem = (
		event: React.MouseEvent<HTMLElement>
	) => {
		event.stopPropagation();
		if (props && props.row) {
			props.onDelete!(props.row);
		}
	};

	const { checkAcl, checkAccess } = useAuthorization();
	return (
		<Box className={classes.container}>
			<Menu
				opened={props.opened}
				shadow="xs"
				classNames={styles}
			>
				<Menu.Target>
					<ActionIcon
						variant="transparent"
						data-testid="W2FtGXR5_Z5jdHi6B-menu"
						className={classes.customSize}
						onClick={(event) => {
							event.stopPropagation();
						}}
					>
						<Image
							w={rem(25)}
							h={rem(25)}
							fit="contain"
							src={IconDotsVertical}
						/>
					</ActionIcon>
				</Menu.Target>
				<Menu.Dropdown>
					<Menu.Item
						data-testid="W2FtGXR7_Z5jdHi6B-menu"
						onClick={handleviewmore}
						color="var(--mantine-color-black)"
						className={styles.item}
						leftSection={
							<Image
								w={rem(20)}
								h={rem(20)}
								fit="contain"
								src={IconExternalLink}
							/>
						}
					>
						{t('global.viewMore')}
					</Menu.Item>
					<Menu.Divider />
					{checkAcl(ACLS.API_TOKENS.DELETE) && (
						<Menu.Item
							data-testid="W2FtGXR6_Z5jdHi6B-menu"
							onClick={handledeleteitem}
							className={styles.item}
							color="red"
							leftSection={
								<IconTrash
									style={{
										width: rem(20),
										height: rem(20),
									}}
								/>
							}
						>
							{t('global.delete')}
						</Menu.Item>
					)}
				</Menu.Dropdown>
			</Menu>
		</Box>
	);
};
